import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-12 md:py-14 px-6 bg-white" data-id="element-118">
      <div className="max-w-3xl mx-auto" data-id="element-119">
        <FadeIn data-id="element-120">
          <div className="mb-8 text-center" data-id="element-121">
            <svg className="w-7 h-7 text-gold mx-auto mb-4 opacity-50" fill="currentColor" viewBox="0 0 24 24" data-id="element-122">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-123" />
            </svg>
            <p className="text-lg md:text-xl font-serif text-navy leading-relaxed italic" data-id="element-124">
              "Sabes exactamente cómo se siente. El despertador suena y el peso
              de las cobijas parece de cien kilos. No es pereza, es una
              parálisis profunda que te susurra que hoy tampoco podrás."
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 text-base md:text-lg text-navy/80 leading-relaxed" data-id="element-125">
          <FadeIn delay={0.1} data-id="element-126">
            <p data-id="element-127">
              Intentas obligarte a levantarte, te gritas internamente que debes
              tener más fe o más disciplina, pero el cuerpo simplemente no
              responde. Te sientes fallándole a Dios, a tu familia y a ti mismo
              antes de que den las 8:00 AM.
            </p>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-128">
            <div className="h-px w-20 bg-divider mx-auto my-6" data-id="element-129"></div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-130">
            <h2 className="font-serif text-2xl md:text-3xl text-navy mb-3 text-center" data-id="element-131">
              La batalla invisible de la mañana
            </h2>
            <p data-id="element-132">
              La depresión de alta funcionalidad no te quita el trabajo, te
              quita la mañana. Te deja atrapado en un ciclo de culpa donde
              castigas a tu cuerpo por no tener la energía que tu mente le
              exige.
            </p>
          </FadeIn>

          <FadeIn delay={0.25} data-id="element-133">
            <p data-id="element-134">
              Has intentado alarmas ruidosas, café inmediato o promesas de
              "mañana será diferente", pero nada funciona porque estás tratando
              de encender un motor que no tiene combustible. Tu sistema nervioso
              está en modo de supervivencia y tu espíritu está agotado de luchar
              solo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}